import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { LoginService } from '../pages/login/login.service';

export const guestGuard: CanActivateFn = (route) => {
    const loginService = inject(LoginService);
    const router = inject(Router);

    if (!loginService.isLoggedIn()) {
        return true;
    }

    const returnUrl = route.queryParamMap.get('returnUrl');

    return loginService.resolveAuthenticatedDestination(returnUrl).pipe(
        take(1),
        map((url) => {
            void router.navigateByUrl(url);
            return false;
        })
    );
};
